import { render, staticRenderFns } from "./primary-pink-button.vue?vue&type=template&id=2b28ae2d&scoped=true&"
import script from "./primary-pink-button.vue?vue&type=script&lang=js&"
export * from "./primary-pink-button.vue?vue&type=script&lang=js&"
import style0 from "./primary-pink-button.vue?vue&type=style&index=0&id=2b28ae2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b28ae2d",
  null
  
)

export default component.exports